// Lightweight gtag wrapper. Auto-no-ops when VITE_GA_MEASUREMENT_ID is unset
// so dev + preview builds don't accidentally send hits.

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

const GA_ID = import.meta.env.VITE_GA_MEASUREMENT_ID as string | undefined;
let booted = false;

export function bootstrapAnalytics(): void {
  if (booted || !GA_ID || typeof window === 'undefined') return;
  booted = true;

  // Inject gtag.js
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA_ID)}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer ?? [];
  window.gtag = function gtag() { window.dataLayer!.push(arguments); };
  window.gtag('js', new Date());
  // We send pageviews manually on route changes, so disable the automatic one.
  window.gtag('config', GA_ID, { send_page_view: false });
}

export function trackPageview(path: string): void {
  if (!GA_ID || !window.gtag) return;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.origin + path,
    page_title: document.title,
  });
}

export function trackEvent(name: string, params?: Record<string, unknown>): void {
  if (!GA_ID || !window.gtag) return;
  window.gtag('event', name, params ?? {});
}
